<template>
  <div
    class="agent-sticker"
    :class="{'is-on': showDetails}"
  >
    <div class="agent-sticker__container">
      <div class="agent-sticker__avatar" v-if="avatar">
        <img :src="avatar" :alt="agent.agentName">
      </div>
      <div class="agent-sticker__content">
        <div class="agent-sticker__overflow" ref="content">
          <div class="agent-sticker__main" ref="main">
            <img :src="logo" :alt="agent.brokerageName" v-if="logo">
            <div class="agent-sticker__logo-text" v-if="!logo">{{ agent.brokerageName }}</div>
            <p class="small" v-if="logo">{{ agent.brokerageName }}</p>
            <p class="big">{{ agent.agentName }}</p>
            <p>{{ agent.agentTitle }}</p>
          </div>
          <div class="agent-sticker__details">
            <ul>
              <li>
                <a :href="`tel:${agent.phone}`">
                  <app-icon name="phone" />{{ agent.phone }}
                </a>
              </li>
              <li>
                <a :href="`mailto:${agent.email}`" :title="agent.email">
                  <app-icon name="envelope" />{{ formatEmail }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="agent-sticker__button-more" @click="toggleDetails">
      <app-icon name="arrow-down" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { get } from 'lodash'

  import Icon from '@/components/icon'

  export default {
    components: {
      appIcon: Icon
    },
    data () {
      return {
        showDetails: false,
        minHeightContent: 0
      }
    },
    computed: {
      ...mapState('tours', ['agent']),
      avatar () {
        return get(this.agent.avatar, '[0].urls[2].url')
      },
      logo () {
        return get(this.agent.logo, '[0].urls[2].url')
      },
      formatEmail () {
        return `@${this.agent.email.split('@')[0]}`
      }
    },
    methods: {
      setMaxHeight (value, important) {
        this.$refs.content.setAttribute(
          'style', `max-height: ${value}px${important ? ' !important' : ''}`
        )
      },
      toggleDetails () {
        if (this.showDetails) {
          this.setMaxHeight(this.minHeightContent)
        } else {
          this.setMaxHeight(this.$refs.content.scrollHeight, true)
        }

        this.showDetails = !this.showDetails
      }
    },
    mounted () {
      this.minHeightContent = this.$refs.main.scrollHeight
      this.setMaxHeight(this.minHeightContent)
    }
  }
</script>

<style lang="scss">
  @import "~@/styles/variables";
  @import "~@/styles/mixins";

  .agent-sticker {
    align-self: flex-start;
    position: relative;
    margin: 0.3125rem 0 0 1.25rem;
    width: 11.25rem;
    min-width: 11.25rem;
    border-radius: 0.125rem;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    background-color: var(--color-white);

    &.is-on {
      .agent-sticker__button-more {
        .icon {
          transform: rotate(180deg);
        }
      }
    }

    &__container {
      max-height: calc(100vh - 1.125rem);
      overflow: auto;
    }

    &__avatar {
      position: absolute;
      top: 0.625rem;
      left: -2.1875rem;
      width: 3.25rem;
      height: 3.25rem;
      padding: 0.25rem;
      border-radius: 50%;
      background-color: var(--color-white);

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    &__content {
      position: relative;
      padding: 0.625rem 1.25rem;
    }

    &__overflow {
      height: auto;
      max-height: 8.125rem;
      overflow: hidden;
      transition: max-height .3s ease-out;

      @include max-screen($media-header-medium) {
        max-height: 3.75rem !important;
      }
    }

    &__logo-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 3.25rem;
      margin: 0 auto 0.5rem;
      font-size: 0.8125rem;
    }

    &__main {
      padding-bottom: 1rem;
      text-align: center;

      img {
        display: block;
        height: 3.25rem;
        margin: 0 auto 0.5rem;
        object-fit: cover;
      }

      p {
        margin-bottom: 0.25rem;
        font-size: 0.75rem;
        line-height: 1.3;

        &:last-child {
          margin-bottom: 0;
        }

        &.small {
          font-size: 0.625rem;
        }

        &.big {
          font-weight: 700;
        }
      }
    }

    &__details {
      margin-bottom: 0.875rem;
      padding: 0 0.3125rem;

      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 0.0625rem;
        margin: 0 0 0.75rem;
        background-color: var(--color-pink-swan);
      }

      li {
        position: relative;
        margin-bottom: 0.25rem;
      }

      a {
        display: block;
        font-size: 0.8125rem;
        color: var(--color-black);
        line-height: 1.5;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .icon {
        position: relative;
        width: 0.875rem;
        top: 0.0625rem;
        margin-right: 0.5rem;

        path {
          fill: var(--color-amaranth);
        }
      }
    }

    &__button-more {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: -0.8125rem;
      left: 50%;
      margin-left: -0.8125rem;
      width: 1.625rem;
      height: 1.625rem;
      border-radius: 0.1875rem;
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
      background-color: var(--color-mine-shaft);
      cursor: pointer;

      .icon {
        width: 0.9375rem;

        path {
          fill: var(--color-white);
        }
      }
    }
  }
</style>
